const defaultState = {
  stepName:'welcome'
};

const processContextReducer = (state = defaultState, action) => {
    
  switch (action.type) {
    case "ADD_PROCESS_CONTEXT":
      return {
        ...state,
        ...action.payload,
      };
    case "CLEAR_PROCESS_CONTEXT":
      return {
        ...defaultState
      }
    default:
      return { ...state };
  }
};

export default processContextReducer;
